export const isOnline = async (url = '') => {
  if (navigator && !navigator.onLine) {
    return false;
  }

  try {
    await fetch(url);
    return true;
  } catch (_) {
    return false;
  }
};

export const NETWORK_PING_INTERVAL_MS = 1000;
const SLOW_NETWORK_PING_INTERVAL_MS = 3000;
const MIN_NETWORK_SPEED = 1000;

export const NETWORK_STATUS = {
  UNKNOWN: 'UNKNOWN',
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  LOW_NETWORK: 'LOW_NETWORK',
};

const DEFAULT_CONFIG = {
  pingUrl: '',
  slowNetwork() {},
  offline() {},
  online() {},
};

class NetworkSpeedService {
  constructor(config) {
    this.config = { ...DEFAULT_CONFIG, ...config };
    this.pingTime = NETWORK_PING_INTERVAL_MS;
    this.status = NETWORK_STATUS.UNKNOWN;
    this.start();
  }

  start() {
    this.stop();
    this.check();
  }

  stop() {
    clearTimeout(this.timer);
    this.timer = null;
  }

  check() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.ping();
      this.check();
    }, this.pingTime);
  }

  setOffline() {
    this.status = NETWORK_STATUS.OFFLINE;
    this.config.offline();
  }

  setOnline() {
    this.status = NETWORK_STATUS.ONLINE;
    this.pingTime = NETWORK_PING_INTERVAL_MS;
    this.config.online();
  }

  setLowNetwork() {
    this.status = NETWORK_STATUS.LOW_NETWORK;
    this.pingTime = SLOW_NETWORK_PING_INTERVAL_MS;
    this.config.slowNetwork();
  }

  ping() {
    const t1 = Date.now();

    fetch(`${this.config.pingUrl}?t=${t1}`).then(() => {
      const t2 = Date.now();
      const speed = Number(500 / ((t2 - t1) / 1000));

      if (speed < MIN_NETWORK_SPEED) {
        return this.setLowNetwork();
      }

      this.setOnline();

    }).catch((err) => {
      if (err.message.indexOf('Failed to fetch') !== -1 && this.status !== NETWORK_STATUS.OFFLINE) {
        this.setOffline();
      }
    });
  }
}

export default NetworkSpeedService;
